import { getConfiguration } from '../data/utils/configuration';

export function getItemsToRender(baseItems) {
    const conf = getConfiguration();

    const itemTypes = {
        'ROULETTE' : true,
        'ROULETTE_VIDEO' : true
    };
    const itemsMap = {};

    if (conf.bfs?.fms?.length > 0) {
    	for (let kf in conf.bfs.fms) {
    		const item = conf.bfs.fms[kf];
    		if (itemTypes[item.typ] && item.enbm) {
    			// searching for position
    			let positionInNavbar = 0;
				const mobilePosition = item.rmp;
				let availablePosition = false;
				if (mobilePosition) {
					if (mobilePosition.indexOf('AFTER_SPORT_ON_POS_') === 0) {
						// taking the position
						positionInNavbar = window.parseInt(mobilePosition.split('#')[1]);
						availablePosition = true;
					} else if (mobilePosition === 'TOP_LIST') {
						availablePosition = true;
					}
				} else {
					// backup handler: mobilePosition not specified
					availablePosition = true;
				}
				
				if (availablePosition) {
					if (!itemsMap[positionInNavbar]) {
						itemsMap[positionInNavbar] = [];
					}
					itemsMap[positionInNavbar].push(item);
				}
    		}
    	}
    }

    const items = [];
    let sportPosition = 0;
    baseItems?.forEach(bi => {
        if (sportPosition === 0) {
            // check if there are non-sport objects in TOP_LIST position
            const additionalItems = itemsMap[sportPosition];
            additionalItems?.forEach(ai =>
                items.push(ai)
            );
        }
        
        sportPosition++;
        items.push(bi);
        // check if there are non sport objects after this sport
        const additionalItems = itemsMap[sportPosition];
        additionalItems?.forEach(ai =>
            items.push(ai)
        );
    });

    return items;
}
